import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { q } from '../../api/queries';
import { useNames } from '../../api/names';
import { ErrorNotice, Provenance } from '@bounded/ui/state';
import { Empty, Mono, Page, PageHeader, Panel, Skeleton, rowClass } from '@bounded/ui/primitives';
import { useNow } from '@bounded/ui/time';
import { useFormat, useT } from '../../i18n';

export const Route = createFileRoute('/_app/activity')({ component: ActivityPage });

function ActivityPage() {
  const t = useT(); const m = t.activity; const f = useFormat();
  const activity = useQuery(q.activity());
  const names = useNames();
  const now = useNow(10_000);
  return (
    <Page>
      <PageHeader title={m.title} description={m.description} />
      <Panel footer={<Provenance>{m.provenance}</Provenance>}>
        {activity.isPending && <div className="p-4"><Skeleton className="h-24" /></div>}
        {activity.error && <div className="p-4"><ErrorNotice error={activity.error} onRetry={() => void activity.refetch()} /></div>}
        {activity.data?.items.length === 0 && <Empty title={m.emptyTitle}>{m.emptyBody}</Empty>}
        <ul>{activity.data?.items.map((e) => (
          <li key={e.sequence} className={`flex flex-wrap items-baseline justify-between gap-2 ${rowClass}`}>
            <p>{m.line(<span className="font-medium">{names.device(e.device_id)}</span>, m.statuses[e.receipt.status] ?? e.receipt.status, names.project(e.receipt.project_id))} <Mono value={e.receipt.subject_id} className="text-graphite" /></p>
            <span className="text-sm text-graphite" title={f.dateTime(e.received_at)}>{f.ago(e.received_at, now)}</span>
          </li>
        ))}</ul>
      </Panel>
    </Page>
  );
}
